import { PropsWithChildren } from "react";

import { useGetLicenses } from "@/hooks/useGetLicenses/useGetLicenses";

import { Loading } from "@dashboard/library";

export function LicensesWrapper({ children }: PropsWithChildren) {
  const { loading } = useGetLicenses();

  if (loading) {
    return <Loading data-test="licenses-provider" />;
  }

  return children;
}
